export default "__VITE_ASSET__DIp1mVfm__"